import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Loading} from '../lib/index';
import API from '../api';
import OptionsStep from "./OptionsStep";
import Button from "../lib/components/Button";
import Bubble from '../lib/steps_components/text/Bubble';
import ChooseApp from "./ChooseApp";
import TextStepContainer from "../lib/steps_components/text/TextStepContainer";
import ImageContainer from "../lib/steps_components/text/ImageContainer";
import Image from "../lib/steps_components/text/Image";


class ShowApp extends ChooseApp {

    render() {
        const {loading, appointments} = this.state;
        const {
            step, store,
            isFirst,
            avatarStyle,
            isLast,
            isRTL,
            bubbleStyle,
            hideBotAvatar,
            hideUserAvatar,
            botAvatar
        } = this.props;
        const {avatar, user} = step;
        const showAvatar = user ? !hideUserAvatar : !hideBotAvatar;

        const {texts} = store.settings;
        return (
            <div>
                {loading ? (
                    <Loading/>
                ) : (
                    (appointments.length > 0) ? (
                        <OptionsStep
                            options={appointments}
                            step={step}
                            speak={false}
                            triggerNextStep={() => false}
                        />) : (
                        <div>
                            <div style={{
                                marginLeft: "-22px",
                                marginRight: "-22px"
                            }}>
                                <TextStepContainer className={`rsc-ts ${user ? 'rsc-ts-user' : 'rsc-ts-bot'}`}
                                                   user={user}>
                                    <ImageContainer className="rsc-ts-image-container" user={user}>
                                        {
                                            true && (
                                                <Image
                                                    className="rsc-ts-image"
                                                    style={avatarStyle}
                                                    showAvatar={showAvatar}
                                                    user={user}
                                                    src={botAvatar}
                                                    alt="avatar"
                                                />
                                            )
                                        }
                                    </ImageContainer>
                                    <Bubble
                                        className="rsc-ts-bubble"
                                        style={bubbleStyle}
                                        user={user}
                                        showAvatar={showAvatar}
                                        isFirst={isFirst}
                                        isLast={isLast}
                                        isRTL={isRTL}
                                    >{texts.noAppointmentsToCancel}
                                    </Bubble>
                                </TextStepContainer>
                            </div>
                            <Button onClick={() => this.contactClinic()}>
                                {texts.contactClinic}
                            </Button>
                            <br/>
                            <Button onClick={() => this.makeAppointment()}>
                                {texts.makeAppointment}
                            </Button>
                        </div>)
                )}
            </div>
        );
    }
}

ShowApp.propTypes = {
    steps: PropTypes.object,
    triggerNextStep: PropTypes.func,
};

ShowApp.defaultProps = {
    steps: undefined,
    triggerNextStep: undefined,
};


export default ShowApp;
